import React from 'react'
import { AttentionTable, ReportChrome, SectionBlock } from './KPIReportPDF'

// Single-section report: the section's rows plus its trend/breakdown charts
// rendered as images (see pdfCharts.js).
const KPISectionPDF = ({ section, charts, orgSettings, rangeLabel, printedBy }) => (
  <ReportChrome
    orgSettings={orgSettings}
    title={`${section.name} — KPI Report`}
    rangeLabel={rangeLabel}
    printedBy={printedBy}
  >
    {section.attention?.length ? <AttentionTable sections={[section]} /> : null}
    <SectionBlock section={section} charts={charts} />
  </ReportChrome>
)

export default KPISectionPDF
